import { ProtobufEntity } from "@nova/constants"
import { MessageFns } from "@nova/protobuf"

export const encodeColorToNumber = (color: string) => {
    if (color.at(0) !== "#") throw "Invalid hex color"
    let number = 0x00
    for (let i = 1; i < color.length; i += 2) {
        const idx = (i - 1) / 2
        if (idx > 3 || idx < 0) throw "Invalid hex length"
        const n = parseInt(color.substring(i, i + 2), 16)
        number |= n << (8 * (3 - idx))
    }

    // If number has no alpha, set to FF.
    if ((number & 0xff) === 0) number |= 0xff

    return number >>> 0
}

export const decodeNumberToColor = (number: number, options?: { isKml?: boolean }) => {
    // transparent must be 0
    if (!number) return "#00000000"
    number = number >>> 0
    let r = (number >> 24) & 0xff
    let g = (number >> 16) & 0xff
    let b = (number >> 8) & 0xff
    const a = number & 0xff

    if (options?.isKml) [r, g, b] = [b, g, r]

    let hex = `${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`
    let alpha = a.toString(16).padStart(2, "0")

    if ((r || g || b) && !a) {
        alpha = "FF"
    }

    hex = options?.isKml ? alpha + hex : "#" + hex + alpha

    return hex.toUpperCase()
}

export const decodeNumberToRGBA = (number: number) => {
    const r = (number >> 24) & 0xff
    const g = (number >> 16) & 0xff
    const b = (number >> 8) & 0xff
    let a = number & 0xff
    if ((r || g || b) && !a) {
        a = 0xff
    }
    return [r, g, b, a] as [number, number, number, number]
}

export const dateAsNumber = (time: string | Date = new Date()) =>
    Math.round(new Date(time).getTime() / 1000)

export const dateFromNumber = (date?: number) => (date ? new Date(date * 1000) : new Date())

const strokeTypes = {
    normal: 1,
    dashed: 2,
    dotted: 3,
    squared: 4,
}
export type StrokeType = keyof typeof strokeTypes
export const strokeTypeAsNumber = (strokeType: StrokeType) => strokeTypes[strokeType]

const strokeWidths = {
    normal: 1,
    thick: 2,
}
export type StrokeWidth = keyof typeof strokeWidths
export const strokeWidthAsNumber = (strokeWidth: StrokeWidth) => strokeWidths[strokeWidth]
export type ProtoType<U> = U extends MessageFns<infer S> ? S : never
export function createProtobuf<T extends ProtobufEntity>(obj: T, data: ProtoType<T>): ProtoType<T> {
    return obj.create(data)
}

export function encodeProtobuf<T extends ProtobufEntity>(obj: T, data: ProtoType<T>) {
    return obj.encode(data)
}
